<template>
    <div id="supsis-button-old" :class="size" @click="click">
        <slot />
    </div>
</template>
<script>
export default {
    name: "SupsisButtonOld",
    props: {
        size: {
            type: String,
            default: "small",
        },
    },
    methods: {
        click() {
            this.$emit("click");
        },
    },
};
</script>
<style lang="scss">
#supsis-button-old {
    background-color: #ec4b1d;
    border-radius: 4px;
    width: max-content;
    color: white;
    &.small {
        padding: 8px 25px;
    }
    &.medium {
        padding: 8px 35px;
    }
    &.large {
        padding: 8px 45px;
    }
}
</style>
